import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import Config from '../../../Config';
import BtnWhiteBlackBorderSmallSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import {isMobileOnly} from 'react-device-detect';

const ContactUsAction = ({contentData, onCallBackClick, forceButton = false}) => {
  const title = contentData.title.value;
  const icon = contentData.icon?.value?.url;
  const phoneNumber = contentData.phoneNumber.value;
  const actionType = contentData.actionType.value;

  const actionTypeEnum = {
    WHATSAPP: 'whatsapp',
    PHONE: 'phone',
    CALLBACK: 'callback',
  };

  function handleOnOpenWhatsApp() {
    const whatsAppLink = `https://wa.me/${phoneNumber}?force_isolation=true&text=`;
    let win = window.open(whatsAppLink, '_blank');
    win.focus();
  }

  function getIcon() {
    if (icon) {
      return <Image src={Config.epiBaseUrl + icon} alt='icon' />;
    }
    return '';
  }

  function getButton() {
    switch (actionType) {
      case actionTypeEnum.WHATSAPP:
        return (
          <BtnWhiteBlackBorderSmallSize
            text={
              <>
                {getIcon()} {title}
              </>
            }
            onclick={() => {
              handleOnOpenWhatsApp();
            }}
          />
        );
      case actionTypeEnum.PHONE:
        if (!isMobileOnly && !forceButton) {
          return <span className='contact-text-only'>{title}</span>;
        }
        return (
          <BtnWhiteBlackBorderSmallSize
            text={
              <>
                {getIcon()} {title}
              </>
            }
            onclick={() => {
              window.location = `tel:${phoneNumber}`;
            }}
          />
        );
      case actionTypeEnum.CALLBACK:
        return (
          <BtnWhiteBlackBorderSmallSize
            text={
              <>
                {getIcon()} {title}
              </>
            }
            onclick={onCallBackClick}
          />
        );
    }
  }

  return <div className='contactUsAction'>{getButton()}</div>;
};

export default ContactUsAction;
